import React, { useMemo } from 'react';
import { Tabs } from 'antd';
import RealtimeEstimatedIncomePage from './RealtimeEstimatedIncomePage';
import VirtualAccountDailySnapshotPage from './account/VirtualAccountDailySnapshotPage';
import { hasResource } from 'utils/resourceAuth';
import { ResourceCode } from 'constants/resourceCodes';

const RealtimeIncomeStatisticsPage: React.FC = () => {
    const hasEstimated = hasResource([ResourceCode.settlement.SETTLEMENT_REVENUE_REALTIME_ESTIMATED]);
    const hasBusiness = hasResource([ResourceCode.settlement.SETTLEMENT_REVENUE_REALTIME_BUSINESS]);
    const hasReceivable = hasResource([ResourceCode.settlement.SETTLEMENT_REVENUE_REALTIME_RECEIVABLE]);

    const items = useMemo(() => {
        return [
            hasEstimated && {
                label: '预估收入',
                key: 'estimated-income',
                children: <RealtimeEstimatedIncomePage sumType={1} />,
            },
            hasBusiness && {
                label: '业务实收',
                key: 'business-income',
                children: <RealtimeEstimatedIncomePage sumType={2} />,
            },
            hasReceivable && {
                label: '预收账款',
                key: 'receivable',
                children: <VirtualAccountDailySnapshotPage />,
            },
        ].filter(Boolean) as { label: string; key: string; children: React.ReactNode }[];
    }, [hasEstimated, hasBusiness, hasReceivable]);

    return (
        <div className="bg-white rounded-lg shadow-sm p-6">
            <Tabs
                items={items}
                size="large"
                defaultActiveKey="estimated-income"
                destroyInactiveTabPane={true}
            />
        </div>
    );
};

export default RealtimeIncomeStatisticsPage;
